// extracted by mini-css-extract-plugin
export default {"statusCellWithDate":"llNZmpwqSZuKgDfZYevb"};